export const ID_PREFIX = {
  OAUTH_CLIENT: "ac_oauthclient_",
  OAUTH_GRANT: "ac_oauthgrant_",
  OAUTH_REQUEST: "ac_oauthrequest_",
} as const;
